import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import { common } from 'constants/e2eClasses'

export const Wrapper = styled.div.attrs(props => ({
  className: `${common.inputBox || ''}${props.e2eClass || ''}`
}))`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const IconContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row-reverse;
  > * {
    cursor: pointer;
  }

  ${mediaQueries.tablet`
    flex-direction: row;
    margin-left: 15px;
  `};
`

export const Label = styled.label.attrs(props => ({
  className: `${common.inputTitle || ''}${props.e2eClass || ''}`,
  htmlFor: props.forId
}))`
  display: flex;
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  padding: 15px 0;
  ${({ fontSize }) =>
    fontSize &&
    `
    font-size: ${fontSize};
  `}
`

export const StyledInput = styled.input.attrs(props => ({
  className: `${common.input || ''}${props.e2eClass || ''}`
}))`
  flex: 3;
  max-width: 100%;
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.colors.grayLight};
  color: ${({ theme }) => theme.colors.blueDark};
  padding: ${({ padding }) => (padding ? `${padding}px` : '14px')};
  outline: 0;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grayLighter};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.doveGray};
  }

  ${({ success }) =>
    success &&
    css`
      color: ${({ theme }) => theme.colors.green};
      border-color: ${({ theme }) => theme.colors.green};

      &:focus {
        border-color: ${({ theme }) => theme.colors.green};
      }
    `};

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.red};
      border-color: ${({ theme }) => theme.colors.red};

      &:focus {
        border-color: ${({ theme }) => theme.colors.red};
      }
    `};

  ${({ boxShadow, theme }) =>
    boxShadow &&
    `
    box-shadow: 0 2px 10px 0 ${theme.shadow.black26}, 0 2px 5px 0 ${theme.shadow.black06};
  `};
`
